import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router'
import { LoginService } from 'src/app/services/login.service';
import { sha256 } from 'js-sha256'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';


@Component({
  selector: 'app-login-user',
  templateUrl: './login-user.component.html',
  styleUrls: ['./login-user.component.scss']
})
export class LoginUserComponent implements OnInit {
  options: FormGroup;
  hideRequiredControl = new FormControl(false);
  floatLabelControl = new FormControl('auto');
  
  constructor(private router: Router,
    private _login: LoginService,
    private fb: FormBuilder) { 

      this.options = fb.group({
        username:[''],
        password:['']
      });

    }

  alertmsg = false;
  spinner = false;

  ngOnInit(): void {
  }

  login() {
    this._login.loginUser({username:this.options.value.username, 
      password:sha256(this.options.value.password)}).subscribe(res => {
      sessionStorage.setItem('token', res.token)
      this.router.navigate(['/homeuser/'])
      this.spinner = false;
    }, err => {
      this.alertmsg = true
      this.spinner = false;
    })
  }

  candidato(){
    this.router.navigate(['/apply'])

  }

}
